import React, { Fragment, useEffect, useState } from "react";
import { Link, Navigate, useLocation, useSearchParams } from "react-router-dom";
import Tab from "react-bootstrap/Tab";
import Nav from "react-bootstrap/Nav";
import SEO from "../../components/seo";
import LayoutMain from "../../layouts/LayoutMain";
import Breadcrumb from "../../wrappers/breadcrumb/Breadcrumb";
import { useDispatch, useSelector } from "react-redux";
import LoginForm from "../../components/form/LoginForm";
import RegisterForm from "../../components/form/RegisterForm";
import { useTranslation } from "react-i18next";
import { useMemo } from "react";
import useLang from "../../hooks/use-lang";
import BannerOneSingle from "../../components/banner/BannerOneSingle";
import { fetchWebsiteSections } from "../../store/slices/app-slice";
import AnotherLightbox from "yet-another-react-lightbox";
import Thumbnails from "yet-another-react-lightbox/plugins/thumbnails";
import Zoom from "yet-another-react-lightbox/plugins/zoom";
import Fullscreen from "yet-another-react-lightbox/plugins/fullscreen";
import { clickCampaignLink } from "../../store/slices/user-slice";

const LoginRegister = () => {
    let { pathname, state: locationState } = useLocation();
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const LangUtils = useLang();
    const [searchParams, setSearchParams] = useSearchParams();
    const [activeTab, setActiveTab] = useState("login");
    const [open, setOpen] = useState(false);
    const { token } = useSelector((state) => state.user);
    const { benefits } = useSelector((state) => state.app);

    const benefitData = useMemo(() => {
        if (!benefits || benefits.length === 0) {
            return null;
        }

        // last benefits
        let lastBenefits = benefits[benefits.length - 1];
        if (!lastBenefits) {
            return null;
        } else {
            return {
                id: lastBenefits.id,
                title: LangUtils.getLangValue(lastBenefits, "subtitle"),
                image: LangUtils.getLangValue(lastBenefits, "section_image_1"),
                link: lastBenefits.external_url,
            };
        }
    }, [benefits, LangUtils]);

    useEffect(() => {
        dispatch(fetchWebsiteSections());
    }, [dispatch]);

    useEffect(() => {
        // Check for tab parameter in URL
        const tabQuery = searchParams.get("tab");
        if (tabQuery) {
            setActiveTab(tabQuery);
        }
    }, [searchParams]);

    useEffect(() => {
        if (searchParams) {
            let extraParams = {};
            searchParams.forEach((value, key) => {
                console.log(key, value);
                if (
                    key !== "tab" &&
                    key !== "checkout" &&
                    key !== "guest_checkout"
                ) {
                    extraParams[key] = value;
                }
            });

            if (Object.keys(extraParams).length > 0) {
                sessionStorage.setItem(
                    "login_register_extra_params",
                    JSON.stringify(extraParams)
                );
            }

            // Remove the extracted parameters from the URL
            Object.keys(extraParams).forEach((key) => {
                searchParams.delete(key);
            });
            setSearchParams(searchParams);
        }
    }, [searchParams]);

    useEffect(() => {
        if (token && !!sessionStorage.getItem("login_register_extra_params")) {
            dispatch(clickCampaignLink());
        }
    }, [token]);

    const handleSelect = (eventKey) => {
        setActiveTab(eventKey);
        setSearchParams({ tab: eventKey });
    };

    console.log(locationState?.from);
    if (token) {
        // Assume locationState is defined earlier in your code
        let replacedPathname = process.env.PUBLIC_URL + "/";

        if (locationState?.from) {
            replacedPathname = locationState.from.pathname.toString();
            // .replace(process.env.REACT_APP_PATHNAME_PREFIX, "/");

            if (!replacedPathname) {
                replacedPathname = process.env.PUBLIC_URL + "/";
            }
        }

        if (searchParams.get("checkout") == 1) {
            replacedPathname =
                process.env.PUBLIC_URL + "/checkout?guest_checkout=0";
        }

        let search = locationState?.from?.search || "";

        // Create a URLSearchParams object from the search string
        let s = new URLSearchParams(search);

        // Check if guest_checkout exists and is set to '1'
        if (s.get("guest_checkout") === "1") {
            // Set guest_checkout to '0'
            s.set("guest_checkout", "0");
            // Update the search string with the modified search parameters
            search = "?" + s.toString();
        }

        console.log(process.env.REACT_APP_PATHNAME_PREFIX);
        console.log("replacedPathname", replacedPathname);
        console.log("search", search);

        return <Navigate to={`${replacedPathname}${search}`} replace />;
    }

    return (
        <Fragment>
            <SEO
                titleTemplate={t("login__seo_title")}
                description={t("login__seo_desc")}
            />
            <LayoutMain headerTop="visible">
                {/* breadcrumb */}
                <Breadcrumb
                    pages={[
                        {
                            label: t("home__breadcrumb"),
                            path: process.env.PUBLIC_URL + "/",
                        },
                        {
                            label: t("login__breadcrumb"),
                            path: process.env.PUBLIC_URL + pathname,
                        },
                    ]}
                />
                <div className="login-register-area pt-70 pb-100">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-7 col-md-12 ms-auto me-auto">
                                <div className="login-register-wrapper">
                                    <Tab.Container
                                        defaultActiveKey="login"
                                        activeKey={activeTab}
                                        onSelect={handleSelect}
                                    >
                                        <Nav
                                            variant="pills"
                                            className="login-register-tab-list"
                                        >
                                            <Nav.Item>
                                                <Nav.Link active>
                                                    <h4>
                                                        {activeTab === "login"
                                                            ? t(
                                                                  "login__tab_login_register"
                                                              )
                                                            : t(
                                                                  "login__tab_register"
                                                              )}
                                                    </h4>
                                                </Nav.Link>
                                            </Nav.Item>
                                            {/* <Nav.Item>
                                                <Nav.Link eventKey="register">
                                                    <h4>
                                                        {t(
                                                            "login__tab_register"
                                                        )}
                                                    </h4>
                                                </Nav.Link>
                                            </Nav.Item> */}
                                        </Nav>
                                        <Tab.Content>
                                            <Tab.Pane eventKey="login">
                                                <LoginForm
                                                    setActiveTab={setActiveTab}
                                                    checkoutAsGuest={
                                                        searchParams.get(
                                                            "checkout"
                                                        ) == 1
                                                    }
                                                />
                                            </Tab.Pane>
                                            <Tab.Pane eventKey="register">
                                                <RegisterForm
                                                    setActiveTab={setActiveTab}
                                                />
                                            </Tab.Pane>
                                        </Tab.Content>
                                    </Tab.Container>
                                </div>
                            </div>
                        </div>

                        {benefitData && (
                            <div className="row mt-3">
                                <div className="col-lg-7 col-md-12 ms-auto me-auto">
                                    <div onClick={() => setOpen(true)}>
                                        <BannerOneSingle
                                            data={benefitData}
                                            spaceBottomClass="mb-30"
                                        />
                                    </div>
                                    <AnotherLightbox
                                        open={open}
                                        index={0}
                                        close={() => setOpen(false)}
                                        slides={[
                                            {
                                                key: 0,
                                                src: benefitData.image,
                                            },
                                        ]}
                                        plugins={[Thumbnails, Zoom, Fullscreen]}
                                    />
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </LayoutMain>
        </Fragment>
    );
};

export default LoginRegister;
